import { render, staticRenderFns } from "./editData.vue?vue&type=template&id=256842ca&scoped=true&lang=pug"
import script from "./editData.vue?vue&type=script&lang=js"
export * from "./editData.vue?vue&type=script&lang=js"
import style0 from "./editData.vue?vue&type=style&index=0&id=256842ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256842ca",
  null
  
)

export default component.exports